//----------------------------------------------------------------------------
// THIS IS A GENERATED REACT ICON COMPONENT. DO NOT EDIT MANUALLY AT ANY COST!
//----------------------------------------------------------------------------;

import type { IconProps } from "../../types/icon";
import { IconWrapper } from "../IconWrapper";

export const Ping = (allProps: IconProps) => {
  const { svgProps: props, ...restProps } = allProps;
  return (
    <IconWrapper
      componentName="Ping"
      icon={
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <g clipPath="url(#prefix__clip0_21705_3719)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3.24941 11.3215C2.28247 12.464 1.31624 13.6064 0.348645 14.7488C0.0929471 15.0505 0.0863674 15.3976 0.334841 15.6428C0.582007 15.886 0.915264 15.8821 1.21502 15.6316C2.04392 14.9408 2.87216 14.2499 3.70098 13.5591C4.07829 13.2436 4.45692 12.9287 4.85 12.6014C4.36489 12.1123 3.89029 11.6325 3.40518 11.1441C3.34537 11.2124 3.29672 11.2663 3.2494 11.3215L3.24941 11.3215ZM10.0502 15.7985C10.743 15.0216 10.7108 13.6806 10.0896 12.1851C10.1021 12.1621 10.1166 12.1384 10.135 12.1141C11.5404 10.2314 12.9371 8.34302 14.3374 6.45646L14.53 6.64905C14.8429 6.96195 15.3497 6.96129 15.6619 6.64905L15.7658 6.5452C16.078 6.23296 16.0787 5.72615 15.7658 5.41326L10.5867 0.234179C10.2738 -0.0780598 9.76765 -0.0780598 9.45475 0.234179L9.35089 0.337381C9.03865 0.64962 9.03865 1.15708 9.35089 1.46932L9.61711 1.73619C7.7043 3.135 5.79216 4.53448 3.87531 5.92798C3.87334 5.92996 3.87071 5.93061 3.86808 5.93193C2.33451 5.28248 0.929782 5.21806 0.175898 5.97202C0.0891308 6.05945 -0.151452 6.33554 0.139745 6.62672L9.35816 15.8451C9.68157 16.1679 9.94648 15.9023 10.0503 15.7985L10.0502 15.7985ZM6.48674 7.55226C6.09563 7.23215 5.69859 6.94554 5.30287 6.69443C7.00079 5.30811 8.69737 3.92173 10.4064 2.5262L11.301 3.42083C9.68595 4.80584 8.08541 6.17974 6.48677 7.55221L6.48674 7.55226Z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id="prefix__clip0_21705_3719">
              <rect width={16} height={16} fill="white" />
            </clipPath>
          </defs>
        </svg>
      }
      {...restProps}
    />
  );
};
